import * as fromDatatype from "../datatype-library/index";

export interface bl_del_driver_vehicle_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  driver_hdr_guid: fromDatatype.GuidDataFieldInterface;
  vehicle_hdr_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
}

export class bl_del_driver_vehicle_link_RowClass
  implements bl_del_driver_vehicle_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    driver_hdr_guid: fromDatatype.GuidDataFieldInterface;
    vehicle_hdr_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
}
